import React, { useMemo } from 'react'
import { Box, Text, useResponsiveWrapperContext } from '@usap/uicomponents'
import { Table } from '../../table'

const vehicleFitColumn = isDesktop => [
  {
    header: 'Vehicle Name',
    accessor: 'name',
    fallback: '',
    width: isDesktop ? '30%' : '25%',
  },
  {
    header: 'Submodel',
    accessor: 'submodel',
    fallback: 'All Submodels',
    width: isDesktop ? '20%' : '25%',
  },
  {
    header: 'Engine',
    accessor: 'engine',
    fallback: 'All Engines',
    width: isDesktop ? '20%' : '25%',
  },
  {
    header: 'Fitment Information',
    accessor: 'fitnote',
    fallback: '-',
    width: isDesktop ? '30%' : '25%',
  },
]

export default function FitmentTable({ records, redirectToSearch, isFromCheckout }) {
  const { isDesktop } = useResponsiveWrapperContext()

  const columnData = useMemo(() => vehicleFitColumn(isDesktop), [isDesktop])

  const tableData = useMemo(() => records.map(
    ({
      year, make, model, fnotes, ...element
    }) => ({
      name: `${year || ''} ${make || ''} ${model || ''}`,
      fitnote: fnotes,
      ...element,
    }),
  ), [records])

  const styles = useMemo(() => ({
    textWrapper: isDesktop ? { marginTop: 16 } : { marginLeft: 8 },
    fitnoteLink: { cursor: 'pointer', width: 'fit-content' },
  }), [isDesktop])

  return (
    <Box pad="medium">
      <Table
        headerDirection={isDesktop ? 'row' : 'column'}
        title="Your Vehicle Fit Details"
        search={false}
        searchPlaceholder="vehicle"
        data={tableData}
        columns={columnData}
        searchWidth={isDesktop ? '25%' : '100%'}
        padHeader={isDesktop ? 'medium' : 'small'}
        titletype="h3"
        margin={isDesktop ? '0px' : 'small'}
      />
      {isFromCheckout ? '' : (
        <Box style={styles.textWrapper}>
          <Text
            size="small"
            weight={700}
            color="#0300D0"
            style={styles.fitnoteLink}
            onClick={redirectToSearch}
          >
            Check similar parts that fit your vehicle &#62;
          </Text>
        </Box>
      )}
    </Box>
  )
}
